import React from "react";
import PropTypes from "prop-types";

export const RuleStatusPill = ({ type }) => {
	return (
		<div className="RuleStatusPill">
			{type === "blocked" && <div className="RuleStatusPill_item--blocked">Blocked</div>}
			{type === "allowed" && <div className="RuleStatusPill_item--allowed">Allowed</div>}
		</div>
	);
};

RuleStatusPill.propTypes = {
	type: PropTypes.oneOf(["blocked", "allowed"]).isRequired,
};
